<template>
  <div>
    <div class="pd_title">
      <span>{{problem.courseName}}</span>
    </div>
    <div class="pd_stitle">
      <span>{{problem.classname}}</span>
    </div>
    <div class="pd_text">
      <span v-html="problem.text"></span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["problem"],
  data() {
    return {};
  },
};
</script>

<style scoped>
.pd_title {
  font-size: 24px;
}

.pd_stitle {
  font-size: 22px;
  margin-top: 10px;
}

.pd_text {
  font-size: 16px;
  margin-top: 10px;
  height: 400px;
  overflow: auto;

}
</style>



// WEBPACK FOOTER //
// src/components/pages/components/problemDetail.vue